module.exports = __webpack_public_path__ + "img/Infinity.3d402832.svg";